import { Box, Stack } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useMemo } from "react";
import { AnalyticsDatetime } from "../../../utils/analytics-datetime";

import type { ReactionsByEmoji } from "./types";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import type { FC } from "react";

type RowType = ReactionsByEmoji["people"][0] & { id: number };

export const NestedReactionTable: FC<{ row: ReactionsByEmoji }> = ({ row }) => {
  const columns: GridColDef<RowType>[] = useMemo(
    () => [
      {
        field: "first_name",
        headerName: "First Name",
        flex: 1,
      },
      {
        field: "last_name",
        headerName: "Last Name",
        flex: 1,
      },
      {
        field: "timestamp",
        headerName: "Reaction Time",
        flex: 4,
        type: "dateTime",
        renderCell: (params: GridRenderCellParams<RowType, Date>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
    ],
    [],
  );

  const people = useMemo(
    () => row.people.map((person, index) => ({ id: index, ...person })),
    [row],
  );

  return (
    <Box sx={{ ml: "50px" }}>
      <DataGridPro hideFooterRowCount rows={people} columns={columns} disableRowSelectionOnClick />
    </Box>
  );
};
